"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
0 && (module.exports = {
    RouterToolbarHost: null,
    RouterToolbarItem: null
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get RouterToolbarHost () {
        return RouterToolbarHost;
    },
    get RouterToolbarItem () {
        return RouterToolbarItem;
    }
});
function RouterToolbarHost(props) {
    return null;
}
function RouterToolbarItem(props) {
    return null;
}

//# sourceMappingURL=native.js.map
